import { gql } from "@apollo/client";


export const CHECK_IN_PROVENANCE_LOG_FRAGMENT = gql`
    fragment CheckInProvenanceLog on ExhibitionEventCheckinLog {
        id
        ee_id
        user_id
        source
        created_at
        changedFields
        old_qr_generated_at
        new_qr_generated_at
        relUser {
            id
            name
            surname
        }
    }
`;

export const EVENT_CHECK_IN_PROVENANCE_FRAGMENT = gql`
    ${ CHECK_IN_PROVENANCE_LOG_FRAGMENT }

    fragment EventCheckInProvenance on ExhibitionEvent {
        getCheckinLogLast {
            ...CheckInProvenanceLog
        }
        getCheckinLogQrSet {
            ...CheckInProvenanceLog
        }
    }
`;
